import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tx-pagehead" }
const _hoisted_2 = {
  class: "tx-seg tx-mb",
  role: "tablist"
}
const _hoisted_3 = ["aria-selected", "onClick"]
const _hoisted_4 = {
  key: 0,
  class: "tx-card tx-card--flush"
}
const _hoisted_5 = {
  key: 1,
  class: "tx-table"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, "#", -1 /* HOISTED */)
const _hoisted_7 = { class: "tx-hide-sm" }
const _hoisted_8 = { class: "tx-num" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "tx-mono" }
const _hoisted_11 = {
  key: 0,
  class: "tx-muted tx-block"
}
const _hoisted_12 = { class: "tx-hide-sm" }
const _hoisted_13 = { class: "tx-progress" }
const _hoisted_14 = { class: "tx-num" }
const _hoisted_15 = { class: "tx-check tx-mb" }
const _hoisted_16 = { class: "tx-card tx-card--flush" }
const _hoisted_17 = {
  key: 1,
  class: "tx-table"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", null, "#", -1 /* HOISTED */)
const _hoisted_19 = { class: "tx-hide-sm" }
const _hoisted_20 = { class: "tx-num" }
const _hoisted_21 = { class: "tx-num" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("th", null, null, -1 /* HOISTED */)
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "tx-mono" }
const _hoisted_25 = { class: "tx-hide-sm" }
const _hoisted_26 = { class: "tx-num" }
const _hoisted_27 = ["href", "aria-label"]
const _hoisted_28 = { class: "tx-stats" }
const _hoisted_29 = { class: "tx-stat__n tx-stat__n--money" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "tx-card tx-card--flush" }
const _hoisted_32 = { class: "tx-card__head tx-pad" }
const _hoisted_33 = { class: "tx-row__main" }
const _hoisted_34 = { class: "tx-card tx-card--flush" }
const _hoisted_35 = { class: "tx-row__main" }
const _hoisted_36 = {
  key: 0,
  class: "tx-muted"
}
const _hoisted_37 = ["href"]
const _hoisted_38 = { class: "tx-card tx-modal__body tx-modal__body--wide" }
const _hoisted_39 = { class: "tx-card__head" }
const _hoisted_40 = { class: "tx-mono" }
const _hoisted_41 = { class: "tx-table" }
const _hoisted_42 = { class: "tx-num" }
const _hoisted_43 = { class: "tx-num" }
const _hoisted_44 = { class: "tx-num" }
const _hoisted_45 = { class: "tx-num" }
const _hoisted_46 = { class: "tx-num" }
const _hoisted_47 = { class: "tx-num" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { colspan: "3" }
const _hoisted_50 = { class: "tx-num" }
const _hoisted_51 = { colspan: "3" }
const _hoisted_52 = { class: "tx-num" }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { colspan: "3" }
const _hoisted_55 = { class: "tx-num" }
const _hoisted_56 = { class: "tx-formactions" }
const _hoisted_57 = ["href"]
const _hoisted_58 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString($setup.state.t("account.title")), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabs, (tb) => {
        return (_openBlock(), _createElementBlock("button", {
          key: tb.id,
          role: "tab",
          "aria-selected": $setup.tab === tb.id,
          class: _normalizeClass({ on: $setup.tab === tb.id }),
          onClick: $event => ($setup.switchTab(tb.id))
        }, _toDisplayString($setup.state.t(tb.label)), 11 /* TEXT, CLASS, PROPS */, _hoisted_3))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createVNode($setup["Loader"], {
      loading: $setup.loading,
      error: $setup.error,
      onRetry: $setup.load
    }, {
      default: _withCtx(() => [
        _createCommentVNode(" Orders "),
        ($setup.tab === 'orders')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (!$setup.orders.length)
                ? (_openBlock(), _createBlock($setup["Empty"], {
                    key: 0,
                    icon: "receipt"
                  }))
                : (_openBlock(), _createElementBlock("table", _hoisted_5, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_6,
                        _createElementVNode("th", null, _toDisplayString($setup.state.t("common.date")), 1 /* TEXT */),
                        _createElementVNode("th", _hoisted_7, _toDisplayString($setup.state.t("account.delivered")), 1 /* TEXT */),
                        _createElementVNode("th", _hoisted_8, _toDisplayString($setup.state.t("common.total")), 1 /* TEXT */),
                        _createElementVNode("th", null, _toDisplayString($setup.state.t("common.status")), 1 /* TEXT */)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.orders, (o) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: o.name,
                          class: "tx-clickable",
                          onClick: $event => ($setup.openDoc('order', o.name))
                        }, [
                          _createElementVNode("td", _hoisted_10, [
                            _createTextVNode(_toDisplayString(o.name), 1 /* TEXT */),
                            (o.po_no)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_11, "PO " + _toDisplayString(o.po_no), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString($setup.fmtDate(o.transaction_date)), 1 /* TEXT */),
                          _createElementVNode("td", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, [
                              _createElementVNode("span", {
                                style: _normalizeStyle({ width: (o.per_delivered || 0) + '%' })
                              }, null, 4 /* STYLE */)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_14, _toDisplayString($setup.fmtMoney(o.grand_total, o.currency)), 1 /* TEXT */),
                          _createElementVNode("td", null, [
                            _createVNode($setup["Badge"], {
                              status: o.status
                            }, null, 8 /* PROPS */, ["status"])
                          ])
                        ], 8 /* PROPS */, _hoisted_9))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]))
            ]))
          : ($setup.tab === 'invoices')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createCommentVNode(" Invoices "),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.onlyOutstanding) = $event)),
                      type: "checkbox",
                      onChange: $setup.load
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelCheckbox, $setup.onlyOutstanding]
                    ]),
                    _createTextVNode(" " + _toDisplayString($setup.state.t("account.only_outstanding")), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    (!$setup.invoices.length)
                      ? (_openBlock(), _createBlock($setup["Empty"], {
                          key: 0,
                          icon: "receipt"
                        }))
                      : (_openBlock(), _createElementBlock("table", _hoisted_17, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _hoisted_18,
                              _createElementVNode("th", null, _toDisplayString($setup.state.t("common.date")), 1 /* TEXT */),
                              _createElementVNode("th", _hoisted_19, _toDisplayString($setup.state.t("account.due")), 1 /* TEXT */),
                              _createElementVNode("th", _hoisted_20, _toDisplayString($setup.state.t("common.total")), 1 /* TEXT */),
                              _createElementVNode("th", _hoisted_21, _toDisplayString($setup.state.t("account.outstanding")), 1 /* TEXT */),
                              _createElementVNode("th", null, _toDisplayString($setup.state.t("common.status")), 1 /* TEXT */),
                              _hoisted_22
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.invoices, (i) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: i.name,
                                class: "tx-clickable",
                                onClick: $event => ($setup.openDoc('invoice', i.name))
                              }, [
                                _createElementVNode("td", _hoisted_24, _toDisplayString(i.name), 1 /* TEXT */),
                                _createElementVNode("td", null, _toDisplayString($setup.fmtDate(i.posting_date)), 1 /* TEXT */),
                                _createElementVNode("td", _hoisted_25, _toDisplayString($setup.fmtDate(i.due_date)), 1 /* TEXT */),
                                _createElementVNode("td", _hoisted_26, _toDisplayString($setup.fmtMoney(i.grand_total, i.currency)), 1 /* TEXT */),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["tx-num", { 'tx-danger': i.status === 'Overdue' }])
                                }, _toDisplayString($setup.fmtMoney(i.outstanding_amount, i.currency)), 3 /* TEXT, CLASS */),
                                _createElementVNode("td", null, [
                                  _createVNode($setup["Badge"], {
                                    status: i.status
                                  }, null, 8 /* PROPS */, ["status"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("a", {
                                    href: $setup.downloadUrl('account.invoice_pdf', { name: i.name }),
                                    class: "tx-iconbtn",
                                    "aria-label": $setup.state.t('account.pdf'),
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    _createVNode($setup["Icon"], {
                                      name: "download",
                                      size: "16"
                                    })
                                  ], 8 /* PROPS */, _hoisted_27)
                                ])
                              ], 8 /* PROPS */, _hoisted_23))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ]))
                  ])
                ])
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            : ($setup.tab === 'statement')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createCommentVNode(" Statement "),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.statement.totals, (s) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: s.currency,
                          class: _normalizeClass(["tx-stat", { 'tx-stat--danger': s.overdue > 0 }])
                        }, [
                          _createElementVNode("span", _hoisted_29, _toDisplayString($setup.fmtMoney(s.outstanding, s.currency)), 1 /* TEXT */),
                          _createElementVNode("span", null, _toDisplayString($setup.state.t("account.outstanding")) + " · " + _toDisplayString(s.currency), 1 /* TEXT */),
                          (s.overdue)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_30, _toDisplayString($setup.state.t("account.overdue")) + ": " + _toDisplayString($setup.fmtMoney(s.overdue, s.currency)) + " (" + _toDisplayString(s.overdue_count) + ")", 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ], 2 /* CLASS */))
                      }), 128 /* KEYED_FRAGMENT */)),
                      (!$setup.statement.totals.length)
                        ? (_openBlock(), _createBlock($setup["Empty"], {
                            key: 0,
                            icon: "check"
                          }))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("h2", null, _toDisplayString($setup.state.t("account.payments")), 1 /* TEXT */)
                      ]),
                      (!$setup.statement.recent_payments.length)
                        ? (_openBlock(), _createBlock($setup["Empty"], {
                            key: 0,
                            icon: "receipt"
                          }))
                        : _createCommentVNode("v-if", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.statement.recent_payments, (p) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: p.name,
                          class: "tx-row"
                        }, [
                          _createElementVNode("span", _hoisted_33, [
                            _createElementVNode("strong", null, _toDisplayString($setup.fmtMoney(p.paid_amount, p.currency)), 1 /* TEXT */),
                            _createElementVNode("small", null, _toDisplayString($setup.fmtDate(p.posting_date)) + " · " + _toDisplayString(p.mode_of_payment || "") + " " + _toDisplayString(p.reference_no ? "· " + p.reference_no : ""), 1 /* TEXT */)
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
              : ($setup.tab === 'documents')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createCommentVNode(" Documents "),
                    _createElementVNode("div", _hoisted_34, [
                      (!$setup.documents.length)
                        ? (_openBlock(), _createBlock($setup["Empty"], {
                            key: 0,
                            icon: "file"
                          }))
                        : _createCommentVNode("v-if", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.documents, (d) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: d.name,
                          class: "tx-row"
                        }, [
                          _createElementVNode("span", _hoisted_35, [
                            _createElementVNode("strong", null, _toDisplayString(d.title), 1 /* TEXT */),
                            _createElementVNode("small", null, [
                              _createTextVNode(_toDisplayString(d.category) + " · " + _toDisplayString(d.file_name), 1 /* TEXT */),
                              (d.remaining !== null)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" · " + _toDisplayString(d.remaining) + " " + _toDisplayString($setup.state.t("account.remaining")), 1 /* TEXT */)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true)
                            ]),
                            (d.description)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_36, _toDisplayString(d.description), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("a", {
                            href: $setup.downloadUrl('documents.download', { grant: d.name }),
                            class: "tx-btn tx-btn--ghost tx-btn--sm"
                          }, [
                            _createVNode($setup["Icon"], {
                              name: "download",
                              size: "16"
                            }),
                            _createTextVNode(_toDisplayString($setup.state.t("common.download")), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_37)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["loading", "error"]),
    ($setup.doc)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "tx-modal",
          role: "dialog",
          "aria-modal": "true",
          onClick: _cache[3] || (_cache[3] = _withModifiers($event => ($setup.doc = null), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("h2", _hoisted_40, _toDisplayString($setup.doc.name), 1 /* TEXT */),
              _createVNode($setup["Badge"], {
                status: $setup.doc.status
              }, null, 8 /* PROPS */, ["status"])
            ]),
            _createElementVNode("table", _hoisted_41, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString($setup.state.t("account.items")), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_42, _toDisplayString($setup.state.t("account.qty")), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_43, _toDisplayString($setup.state.t("account.rate")), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_44, _toDisplayString($setup.state.t("account.amount")), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.doc.items, (it, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, _toDisplayString(it.item_name), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_45, _toDisplayString(it.qty) + " " + _toDisplayString(it.uom), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_46, _toDisplayString($setup.fmtMoney(it.rate, $setup.doc.currency)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_47, _toDisplayString($setup.fmtMoney(it.amount, $setup.doc.currency)), 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("tfoot", null, [
                ($setup.doc.total_taxes_and_charges)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [
                      _createElementVNode("td", _hoisted_49, _toDisplayString($setup.state.t("account.tax")), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_50, _toDisplayString($setup.fmtMoney($setup.doc.total_taxes_and_charges, $setup.doc.currency)), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_51, [
                    _createElementVNode("strong", null, _toDisplayString($setup.state.t("common.total")), 1 /* TEXT */)
                  ]),
                  _createElementVNode("td", _hoisted_52, [
                    _createElementVNode("strong", null, _toDisplayString($setup.fmtMoney($setup.doc.grand_total, $setup.doc.currency)), 1 /* TEXT */)
                  ])
                ]),
                ($setup.doc.outstanding_amount !== undefined)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_53, [
                      _createElementVNode("td", _hoisted_54, _toDisplayString($setup.state.t("account.outstanding")), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_55, _toDisplayString($setup.fmtMoney($setup.doc.outstanding_amount, $setup.doc.currency)), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              ($setup.docKind === 'invoice')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: $setup.downloadUrl('account.invoice_pdf', { name: $setup.doc.name }),
                    class: "tx-btn tx-btn--ghost"
                  }, [
                    _createVNode($setup["Icon"], {
                      name: "download",
                      size: "16"
                    }),
                    _createTextVNode(_toDisplayString($setup.state.t("account.pdf")), 1 /* TEXT */)
                  ], 8 /* PROPS */, _hoisted_57))
                : _createCommentVNode("v-if", true),
              ($setup.state.modules.services)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: $setup.queryLink,
                    "data-nav": "",
                    class: "tx-btn tx-btn--ghost"
                  }, _toDisplayString($setup.state.t("account.query")), 9 /* TEXT, PROPS */, _hoisted_58))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                class: "tx-btn tx-btn--primary",
                onClick: _cache[2] || (_cache[2] = $event => ($setup.doc = null))
              }, _toDisplayString($setup.state.t("common.close")), 1 /* TEXT */)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}